<template>
  <div class="subscription-wrapper">
    <page-header :title="$t('bill.subscription_create')" />
    <page-body needMarginBottom>
      <a-row :gutter="30">
        <a-col :md="{ span: 24 }" :lg="{ span: 22 }" :xl="{ span: 16 }" :xxl="{ span: 14 }">
          <a-form
            class="mt-3"
            :form="form.fc"
            v-bind="formItemLayout"
            hideRequiredMark>
            <scope-radio
              :decorators="decorators"
              :form="form"
              :label="$t('bill.subscription_scope')"
              @change="scopeChange" />
            <a-form-item :label="$t('common.name')">
              <a-input v-decorator="decorators.name" :placeholder="$t('validator.resourceName')" />
              <!-- <name-repeated
                v-slot:extra
                res="costreports"
                version="v1"
                :name="form.fd.name" /> -->
            </a-form-item>
            <a-form-item :label="$t('common.billing_scope')" :extra="billingScopeExtra">
              <range-scope
                v-decorator="decorators.data_range"
                :subscriptionScope="form.fd.scope"
                :domain="form.fd.domain" />
            </a-form-item>
            <a-form-item :label="$t('bill.budget_currency')">
              <a-radio-group v-decorator="decorators.billing_type" @change="billTypeChangeHandle">
                <a-radio-button v-for="item in COST_REPORT_BILLING_TYPES" :value="item.key" :key="item.key">{{ item.value }}</a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item :label="$t('bill.text_198')" v-if="form.fc.getFieldValue('billing_type') === 'custom'">
              <a-range-picker
                v-decorator="decorators.startEndTime"
                :disabled-date="disabledStartDate"
                format="YYYY-MM-DD" />
            </a-form-item>
            <a-form-item :label="$t('bill.alert_frequency')">
              {{ sendingFrequency }}
              <a-popover v-model="visible" trigger="click">
                <div style="width: 550px" slot="content">
                  <a-form-item :label="$t('bill.cycle_type')">
                    <a-radio-group v-decorator="decorators.cycle_type" @change="cycleTypeChangeHandle">
                      <a-radio-button v-for="v in COST_REPORT_PERIOD_TYPES" :key="v.key" :value="v.key">{{v.value}}</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                  <a-form-item :label="$t('bill.cycle_type_week')" v-if="form.fd.cycle_type === 'week'">
                    <a-select v-decorator="decorators.weekDays" @select="weekDaysSelectHandle">
                      <a-select-option v-for="v in WEEK_DAYS" :key="v.key" :value="v.key">{{v.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item :label="$t('bill.cycle_type_day')" v-if="form.fd.cycle_type === 'month'">
                    <a-select v-decorator="decorators.monthDays" @select="monthDaysSelectHandle" style="width: 90px;">
                      <a-select-option v-for="i in 31" :key="i" :value="parseInt(i)">{{$t('cloudenv.text_436', [i])}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <!-- 单次策略 -->
                  <template v-if="form.fd.cycle_type === 'one_time'">
                    <a-form-item :label="$t('cloudenv.text_437')">
                      <a-date-picker
                        :showTime="{
                          format: 'HH:mm',
                        }"
                        :disabledDate="disabledDate"
                        :disabledTime="disabledDateTime"
                        v-decorator="decorators.execTime"
                        format="YYYY-MM-DD HH:mm" />
                    </a-form-item>
                  </template>
                  <a-form-item v-else :label="$t('bill.cycle_type_time')">
                    <a-time-picker v-decorator="decorators.hourMinute" @change="hourMinuteChangeHandle" format="HH:mm" />
                  </a-form-item>
                </div>
                <a-icon type="edit" />
              </a-popover>
            </a-form-item>
            <a-form-item>
              <span slot="label">
                <span>{{$t('bill.bill_prepaid_amortizing')}}</span> <help-tooltip :text="$t('bill.bill_prepaid_amortizing_tips')" />
              </span>
              <a-switch v-decorator="decorators.is_prepaid_amortizing" :checked-children="$t('table.title.on')" :un-checked-children="$t('table.title.off')" />
            </a-form-item>
            <a-form-item v-if="projectSharedShow">
              <span slot="label">
                <span>{{$t('bill.bill_project_sharing')}}</span> <help-tooltip :text="$t('bill.bill_project_sharing_tips')" />
              </span>
              <a-switch v-decorator="decorators.is_project_sharing" :checked-children="$t('table.title.on')" :un-checked-children="$t('table.title.off')" />
            </a-form-item>
            <a-form-item :label="$t('bill.subscription_mail_subject')">
              <a-input v-decorator="decorators.mailSubject" />
            </a-form-item>
            <a-form-item :label="$t('common.notify_type')">
                <a-radio-group v-decorator="decorators.notify_type">
                  <a-radio value="receiver">{{ $t('common.notify_type.receiver') }}</a-radio>
                  <a-radio value="role">{{ $t('dictionary.role') }}</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item
              v-if="form.fd.notify_type === 'receiver'"
              class="mb-0"
              :label="$t('common.notify_type.receiver')"
              :extra="$t('bill.report_email_tips')">
              <base-select
                v-decorator="decorators.user_ids"
                class="w-100"
                :filterable="true"
                resource="receivers"
                version="v1"
                :applyOptionLabel="true"
                :params="recipientParams"
                :select-props="{ placeholder: $t('bill.text_49'), allowClear: true, mode: 'multiple' }" />
              <!--a-textarea
                v-decorator="decorators.emails"
                :auto-size="{ minRows: 2, maxRows: 6 }" /-->
            </a-form-item>
            <a-form-item :label="$t('dictionary.role')" v-if="form.fd.notify_type === 'role'">
              <base-select
                v-decorator="decorators.roles"
                resource="roles"
                version="v1"
                remote
                :params="rolesParams"
                :remote-fn="q => ({ filter: `name.contains(${q})` })"
                :select-props="{ mode: 'multiple' }" />
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button type="primary" class="mr-3" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
        <a-button @click="cancel">{{ $t('dialog.cancel') }}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ScopeRadio from '@/sections/ScopeRadio'
// import NameRepeated from '@/sections/NameRepeated/index'
import RangeScope from '@/sections/RangeScope'
import {
  COST_REPORT_BILLING_TYPES,
  COST_REPORT_BILLING_TYPE_MAP,
  COST_REPORT_PERIOD_TYPES,
  COST_REPORT_PERIOD_TYPE_MAP,
  WEEK_DAYS,
  WEEK_DAY_MAP,
} from '../constants'

const defaultHour = '08:00'

export default {
  name: 'BillSubscriptionCreate',
  components: {
    ScopeRadio,
    // NameRepeated,
    RangeScope,
  },
  data () {
    return {
      loading: false,
      COST_REPORT_BILLING_TYPES,
      COST_REPORT_PERIOD_TYPES,
      WEEK_DAYS,
      sendingFrequency: this.$t('bill.subscription_cycle_type_day', [defaultHour]),
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: (props, values) => {
            Object.keys(values).forEach((key) => {
              this.$set(this.form.fd, key, values[key])
              if (key === 'scope' && values[key] === 'system') {
                this.$set(this.form.fd, 'domain', undefined)
              }
            })
          },
        }),
        fd: {
          cycle_type: 'day',
          exec_time: this.$moment(),
          notify_type: 'receiver',
          scope: this.scope,
        },
      },
      decorators: {
        scope: [
          'scope',
          {
            initialValue: this.$store.getters.scope,
          },
        ],
        domain: [
          'domain',
          {
            rules: [
              { required: true, message: `${this.$t('common.select')}` },
            ],
          },
        ],
        project: [
          'project',
          {
            rules: [
              { required: true, message: `${this.$t('common.select')}` },
            ],
          },
        ],
        name: [
          'name',
          {
            rules: [
              { required: true, message: `${this.$t('common.placeholder')}${this.$t('common.name')}` },
              { validator: this.$validate('resourceName') },
            ],
          },
        ],
        billing_type: [
          'billing_type',
          {
            initialValue: 'current_month',
          },
        ],
        is_prepaid_amortizing: [
          'is_prepaid_amortizing',
          {
            initialValue: false,
          },
        ],
        is_project_sharing: [
          'is_project_sharing',
          {
            initialValue: false,
          },
        ],
        cycle_type: [
          'cycle_type',
          {
            initialValue: 'day',
            rules: [
              { required: true, message: this.$t('cloudenv.text_443') },
            ],
          },
        ],
        startEndTime: [
          'startEndTime',
          {
            // initialValue: [1],
            rules: [
              { required: true, message: this.$t('cloudenv.text_447') },
            ],
          },
        ],
        execTime: [
          'exec_time',
          {
            initialValue: this.$moment(),
            rules: [
              { required: true, message: this.$t('cloudenv.text_437') },
            ],
          },
        ],
        weekDays: [
          'week_days',
          {
            initialValue: 1,
            rules: [
              { required: true, message: this.$t('cloudenv.text_444') },
            ],
          },
        ],
        monthDays: [
          'month_days',
          {
            initialValue: 4,
            rules: [
              { required: true, message: this.$t('cloudenv.text_445') },
            ],
          },
        ],
        // 小时：分钟
        hourMinute: [
          'hourMinute',
          {
            initialValue: this.$moment({ hour: 8 }),
            rules: [
              { required: true, message: this.$t('cloudenv.text_446') },
            ],
          },
        ],
        mailSubject: [
          'mail_subject',
          {
            initialValue: 'Billing Report',
            rules: [
              { required: true, message: this.$t('common.tips.input', [this.$t('bill.subscription_mail_subject')]) },
            ],
          },
        ],
        user_ids: [
          'user_ids',
          {
            rules: [
              { required: true, message: this.$t('bill.text_240') },
            ],
          },
        ],
        /* emails: [
          'emails',
          {
            rules: [
              { required: true, message: this.$t('common.tips.input', [this.$t('bill.report_email')]) },
              { validator: this.validateEmails },
            ],
          },
        ], */
        data_range: [
          'data_range',
          {
            initialValue: { range_scope: 'system', domain_id: '', project_id: '' },
          },
        ],
        notify_type: [
          'notify_type',
          {
            initialValue: 'receiver',
          },
        ],
        roles: [
          'roles',
          {
            rules: [
              {
                required: true,
                message: this.$t('rules.role'),
              },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
      visible: false,
    }
  },
  computed: {
    ...mapGetters(['scope', 'userInfo', 'isDomainMode']),
    ...mapState('bill', {
      projectSharedShow: state => state.projectSharedShow,
    }),
    recipientParams () {
      const params = {
        limit: 0,
        scope: this.scope,
        with_meta: true,
        enabled: true,
        verified_contact_type: 'email',
      }
      if (this.isDomainMode) {
        params.project_domain_filter = true
      }
      return params
    },
    rolesParams () {
      const params = {
        scope: this.scope,
      }
      return params
    },
    billingScopeExtra () {
      if (this.form.fd.data_range?.range_scope === 'any_domain') {
        return this.$t('common.data_range.any_domain_extra')
      }
      if (this.form.fd.data_range?.range_scope === 'any_project') {
        return this.$t('common.data_range.any_project_extra')
      }
      return ''
    },
  },
  watch: {
    visible (v) {
      if (v) {
        this.form.fc.setFieldsValue({
          cycle_type: this.form.fd.cycle_type || 'day',
          week_days: this.form.fd.week_days || 1,
          month_days: this.form.fd.month_days || 4,
          hourMinute: this.form.fd.hourMinute || this.$moment({ hour: 8 }),
        })
      }
    },
    'form.fd.exec_time' (val) {
      if (val && this.visible && this.form.fd.cycle_type === 'one_time') {
        this.sendingFrequency = this.$moment(val).format('YYYY-MM-DD HH:mm')
      }
    },
  },
  created () {
    this.costreportsManager = new this.$Manager('costreports', 'v1')
    this.initDataRange()
  },
  methods: {
    initDataRange () {
      this.$nextTick(() => {
        this.form.fc.setFieldsValue({
          data_range: { range_scope: this.scope, domain_id: '', project_id: '' },
        })
      })
    },
    doCreate (data) {
      return this.costreportsManager.create({
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const {
          scope,
          project,
          domain,
          name,
          billing_type,
          week_days = 1,
          month_days = 4,
          hourMinute = this.$moment({ hour: 8 }),
          // emails = '',
          startEndTime,
          mail_subject,
          user_ids,
          data_range,
          roles,
          notify_type,
          is_prepaid_amortizing,
          is_project_sharing,
        } = await this.form.fc.validateFields()
        const cycle_type = this.form.fd.cycle_type
        const params = {
          name,
          billing_type,
          period_type: cycle_type,
          scope,
          subject: mail_subject,
          enabled: true,
          exchanged_currency: '',
          is_prepaid_amortizing: is_prepaid_amortizing,
        }
        if (project) {
          params.project_id = project
        }
        if (domain) {
          params.domain_id = domain
        }
        if (this.projectSharedShow) {
          params.is_project_sharing = is_project_sharing
        }
        if (billing_type === COST_REPORT_BILLING_TYPE_MAP.current_month.key) {
          // params.colon_timer = hourMinute.format('HH:mm')
        } else if (billing_type === COST_REPORT_BILLING_TYPE_MAP.custom.key) {
          params.billing_start_date = startEndTime[0]
          params.billing_end_date = startEndTime[1]
          // params.colon_timer = hourMinute.format('HH:mm')
        }
        /* if (emails) {
          params.emails = emails.split('\n')
        } */
        if (cycle_type === 'week') {
          params.day = week_days
          params.colon_timer = hourMinute.utc().format('HH:mm')
        } else if (cycle_type === 'month') {
          params.day = month_days
          params.colon_timer = hourMinute.utc().format('HH:mm')
        } else if (cycle_type === 'day') {
          params.colon_timer = hourMinute.utc().format('HH:mm')
        } else if (cycle_type === 'one_time') {
          params.event_start_date = this.form.fd.exec_time?.format('YYYY-MM-DDTHH:mm:ssZ')
        }
        this.generateNotifyData(params, notify_type, user_ids, roles)
        this.generateRangeScope(params, data_range)
        await this.doCreate(params)
        // this.$router.push({ name: 'BillSubscription' })
        this.$router.push({
          path: '/billsummary',
          query: {
            type: 'subscription',
          },
        })
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    hide () {
      this.visible = false
    },
    cancel () {
      // this.$router.push({ name: 'BillSubscription' })
      this.$bus.$emit('summaryTypeChange', 'subscription')
      this.$router.push({
        path: '/billsummary',
        query: {
          type: 'subscription',
        },
      })
    },
    validateEmails (rule, value, callback) {
      if (value) {
        const isOk = value.split('\n').every(v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(v))
        if (isOk) {
          callback()
        } else {
          callback(new Error(this.$t('validator.email')))
        }
      }
      callback()
    },
    disabledStartDate (date) {
      const current = date.endOf('day')
      if (this.form.fd.end_time && current) {
        return current < this.form.fd.end_time.endOf('day') || current > this.$moment().endOf('day')
      }
      return current && current > this.$moment().endOf('day')
    },
    disabledDate (current) {
      return current && current < this.$moment().subtract(1, 'd').endOf('day')
    },
    range (start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    disabledDateTime (_ = this.$moment(), type) {
      let disabledHours = []
      let disabledMinutes = []
      let disabledSeconds = []
      const dayDiff = _.diff(this.$moment(), 'days', true)
      const hourDiff = _.diff(this.$moment(), 'hours', true)
      const minutesDiff = _.diff(this.$moment(), 'minutes', true)
      // 当天
      if (dayDiff > -1 && dayDiff < 0) {
        disabledHours = this.range(0, this.$moment().hour())
        if (hourDiff > -1 && hourDiff < 0) {
          disabledMinutes = this.range(0, this.$moment().minute())
          if (minutesDiff > -1 && minutesDiff < 0) {
            disabledSeconds = this.range(0, this.$moment().second())
          }
        }
      }
      return {
        disabledHours: () => disabledHours,
        disabledMinutes: () => disabledMinutes,
        disabledSeconds: () => disabledSeconds,
      }
    },
    billTypeChangeHandle (e) {
      const hour = defaultHour
      const billing_type = e.target.value
      let cycle_type = 'day'

      if (billing_type === COST_REPORT_BILLING_TYPE_MAP.current_month.key) {
        cycle_type = 'day'
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_day', [hour])
      } else if (billing_type === COST_REPORT_BILLING_TYPE_MAP.last_month.key) {
        cycle_type = 'month'
        const md = this.form.fd.month_days || 4
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_month', [md, hour])
      } else if (billing_type === COST_REPORT_BILLING_TYPE_MAP.custom.key) {
        cycle_type = 'one_time'
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_one_time')
      }
      this.form.fd.cycle_type = cycle_type
      this.decorators.cycle_type[1].initialValue = cycle_type
    },
    cycleTypeChangeHandle (e) {
      const hour = defaultHour
      const cycle_type = e.target.value

      if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.one_time.key) {
        this.sendingFrequency = this.form.fd.exec_time?.format('YYYY-MM-DD HH:mm')
      } else if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.day.key) {
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_day', [hour])
      } else if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.week.key) {
        const wd = WEEK_DAY_MAP[1].value
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_week', [wd, hour])
      } else if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.month.key) {
        const md = 4
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_month', [md, hour])
      }
      this.form.fd.hourMinute = this.$moment({ hour: 8 })
      this.form.fc.setFieldsValue({ hourMinute: this.$moment({ hour: 8 }) })
    },
    weekDaysSelectHandle (v) {
      const hour = this.form.fd.hourMinute?.format('HH:mm') || defaultHour
      const wd = WEEK_DAY_MAP[v || 1].value
      this.sendingFrequency = this.$t('bill.subscription_cycle_type_week', [wd, hour])
    },
    monthDaysSelectHandle (v) {
      const hour = this.form.fd.hourMinute?.format('HH:mm') || defaultHour
      this.sendingFrequency = this.$t('bill.subscription_cycle_type_month', [v || 4, hour])
    },
    hourMinuteChangeHandle (v) {
      const hour = v?.format('HH:mm') || defaultHour
      const cycle_type = this.form.fd.cycle_type

      if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.one_time.key) {
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_one_time')
      } else if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.day.key) {
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_day', [hour])
      } else if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.week.key) {
        const wd = WEEK_DAY_MAP[this.form.fd.week_days || 1].value
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_week', [wd, hour])
      } else if (cycle_type === COST_REPORT_PERIOD_TYPE_MAP.month.key) {
        const md = this.form.fd.month_days || 4
        this.sendingFrequency = this.$t('bill.subscription_cycle_type_month', [md, hour])
      }
    },
    generateRangeScope (params, data_range) {
      const { range_scope, domain_id, project_id } = data_range
      const { domain, project } = this.form.fd

      if (params.scope === 'system') {
        if (range_scope === 'domain' || range_scope === 'any_project_in_domain') {
          params.domain_id = domain_id
        } else if (range_scope === 'project') {
          params.project_id = project_id
        }
      } else if (params.scope === 'domain') {
        if (range_scope === 'any_project_in_domain') {
          params.domain_id = domain
        } else if (range_scope === 'project') {
          params.project_id = project_id
        }
      } else if (params.scope === 'project') {
        params.project_id = project
      }
      params.bill_scope = range_scope
    },
    generateNotifyData (params, notify_type, user_ids, roles) {
      if (notify_type === 'receiver') {
        params.user_ids = user_ids
      } else if (notify_type === 'role') {
        params.role_ids = roles
      }
      params.notify_type = notify_type === 'receiver' ? 'user' : notify_type
    },
  },
}
</script>
